import React from "react";

import Section from "../../components/Section/Section";

const HeroSm = ({ title }) => {
  return (
    <Section id="hero-sm">
      <h2>{title}</h2>
    </Section>
  );
};

export default HeroSm;
